import { put, takeEvery } from 'redux-saga/effects';
import { ACT_USERS_FETCH_INIT } from '../constants/actions';
import { fetchUsersSuccessAction } from '../actions/usersActions';
import Api from '../services/Api';

function* fetchUsers() {
  const { status, data } = yield Api.get('/users');
  if (status === 200) {
    yield put(fetchUsersSuccessAction(data.data));
  }
}

export default function* usersSagas() {
  yield takeEvery(ACT_USERS_FETCH_INIT, fetchUsers);
}
